module.exports = __webpack_public_path__ + "img/better-doubles.9202d1c2.jpg";